import { ReactNode } from 'react'

import { FormField, SegmentedControl } from '@cloudscape-design/components'
import { merge } from 'lodash'

export type LabeledSegmentedProps = {
    label: string,
    value: string, 
    options: string,
    onChange: (newValue: string) => void, 
    validate?: (value: string, label: string) => boolean,
    readOnly?: boolean, 
    [rest: string]: any,
}

export default ({ label, value, options, onChange, validate, readOnly, ...rest }: LabeledSegmentedProps): ReactNode => {

    const valid = (!readOnly && validate) ? validate(value, label) : true

    return (
        <FormField label={label} info={!validate || readOnly ? 'Optional' : ''} >
            <SegmentedControl 
                selectedId={value}
                onChange={({ detail }) => {
                    onChange(detail.selectedId)}}
                // label={label}
                options= {options.split(';').map((option: string) => ({id: option, text: option}))}
                {...rest}
            />
        </FormField> 
    )
}